"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.width500 = exports.width400 = exports.width0 = exports.radiusSmall = exports.radiusRound = exports.radiusMedium = exports.radiusLarge = exports.radiusFull = exports.radius900 = exports.radius550 = exports.radius500 = exports.radius450 = exports.radius400 = exports.radius350 = exports.radius300 = exports.radius200 = void 0;
const radius200 = exports.radius200 = "4px";
const radius300 = exports.radius300 = "8px";
const radius350 = exports.radius350 = "12px";
const radius400 = exports.radius400 = "16px";
const radius450 = exports.radius450 = "24px";
const radius500 = exports.radius500 = "28px";
const radius550 = exports.radius550 = "36px";
const radius900 = exports.radius900 = "999999px";
const radiusRound = exports.radiusRound = "999999px";
const radiusSmall = exports.radiusSmall = "8px";
const radiusMedium = exports.radiusMedium = "12px";
const radiusLarge = exports.radiusLarge = "16px";
const radiusFull = exports.radiusFull = "999999px";
const width0 = exports.width0 = "0px";
const width400 = exports.width400 = "1px";
const width500 = exports.width500 = "2px";